"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAudioEssenceProperty = exports.audioEssencePropertyDefinition = void 0;
exports.audioEssencePropertyDefinition = {
    view: { label: 'Audio essence' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: ['RBMN Audio'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'audio-essence',
};
const isAudioEssenceProperty = (prop) => {
    return prop.name === exports.audioEssencePropertyDefinition.name;
};
exports.isAudioEssenceProperty = isAudioEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaW8tZXNzZW5jZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2F1ZGlvLWVzc2VuY2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUMsWUFBWSxDQUFDO1NBQ3pCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGVBQWU7Q0FDVSxDQUFBO0FBSTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=